const YOUTUBE_VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;

const YOUTUBE_HOSTS = new Set([
  'youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'www.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
]);

function validVideoId(value: string | null | undefined): string | null {
  if (!value) return null;
  return YOUTUBE_VIDEO_ID.test(value) ? value : null;
}

/**
 * Extracts a video id only from recognized YouTube URL forms. Keeping this parser shared
 * ensures the page embed and video sitemap agree on whether an authored URL is renderable.
 */
export function getYouTubeVideoId(value: string): string | null {
  let url: URL;
  try {
    url = new URL(value.trim());
  } catch {
    return null;
  }

  const hostname = url.hostname.toLowerCase();
  if (hostname === 'youtu.be') {
    return validVideoId(url.pathname.split('/').filter(Boolean)[0]);
  }

  if (!YOUTUBE_HOSTS.has(hostname)) return null;

  const pathParts = url.pathname.split('/').filter(Boolean);
  if (pathParts[0] === 'watch') {
    return validVideoId(url.searchParams.get('v'));
  }

  if (pathParts[0] === 'embed' || pathParts[0] === 'shorts' || pathParts[0] === 'live') {
    return validVideoId(pathParts[1]);
  }

  return null;
}
